module.exports = __webpack_public_path__ + "static/miami-b925ca34fe56483fa994fddcbc70ab42.png";